module.exports = __webpack_public_path__ + "img/book-icon.779b1d3e.png";